<div class="newsletter_container">
    <div class="newsletter_content container">
        <div class="newsletter_text">
            <h1>Faça parte da nossa newsletter</h1>
            <p>Fique por dentro de todas as novidades sobre a FundCube!</p>
        </div>

        <form class="newsletter_form" [formGroup]="form">
            <input type="text" pInputText placeholder="Insira o seu melhor e-mail" formControlName="email">
            <button type="button" class="btn_primary" (click)="submit()" [disabled]="loading">
                {{loading ? 'Enviando' : 'Enviar'}}
                <i *ngIf="!loading" class="pi pi-send"></i>
                <i class="pi pi-spin pi-spinner" *ngIf="loading"></i>
            </button>
        </form>
    </div>
</div>